import { option } from '../lib/common'

export const THEME_FORM_FIELD_ELEMENTS = [
  option('All controls', 'all'),
  option('Search', 'search'),
  option('Address Finder', 'addressFinder'),
  option('External Lookup', 'externalLookup'),
  option('Text field', 'text'),
  option('TextArea field', 'textarea'),
  option('Rich TextArea field', 'richtextarea'),
  option('Email field', 'email'),
  option('Number field', 'number'),
  option('Counter field', 'counter'),
  option('Phone field', 'phone'),
  option('Currency field', 'currency'),
  option('Slider', 'slider'),
  option('Url field', 'url'),
  option('Date Range field', 'daterange'),
  option('Date field', 'date'),
  option('Time field', 'time'),
  option('DateTime field', 'datetime'),
  option('Checkbox', 'checkbox'),
  option('Switcher', 'switcher'),
  option('Radio', 'radio'),
  option('Dropdown', 'dropdown'),
  option('MultiSelect', 'multiSelect'),
  option('Button group', 'buttongroup'),
  option('Lookup', 'lookup'),
  option('File Upload', 'upload'),
  option('Signature', 'signature'),
]
